import {searchCriteria} from "./searchCriteria";

export function MonitoringPerformanceDistrictSearchCriteria() {
    return Object.assign({}, searchCriteria("MonitoringPerformanceDistrictSearchCriteria", "districtName", "districtName"), {
        dateWindowId: "",
        district: "",
        needsReview: ""
    });
}